export const activeRealmFilterFactory = () => {
    return (input, realm, enabled) => {
        if (!input) return;

        // check if recent active filter is enabled
        if (!enabled || !realm) {
            // console.log('active filter is disabled');
            return input;
        }

        let output = [];

        for (let i = 0; i < input.length; i++) {
            let row = input[i];
            // console.log('person realm =', realm, 'row realms =', row.pnAssetRealm, row.pnUserRealm);
            if (row.pnAssetRealm === realm || row.pnUserRealm === realm) {
                output.push(row);
            }
        }

        return output;
    };
};
